import {
  SELECT_PAGE,
  RECEIVE_FORM
} from '../actions'

function selectedPage(state = 0, action) {
  switch (action.type) {
  case SELECT_PAGE:
    return action.page
  case RECEIVE_FORM:
    return 0
  default:
    return state
  }
}

export default selectedPage


// WEBPACK FOOTER //
// ./src/reducers/selectedPage.js